import React from 'react';
import styled, { css } from 'react-emotion';
import GatsbyLink from 'gatsby-link';
import utf8 from 'utf8';

const timestamp = css`
  color: #767676;
  font-size: 1rem;
  font-family: 'Titillium Web', monospace;
  margin: 0 0 4px;
`;

const Timestamp = styled.time`
  ${timestamp};
`;

const link = css`
  box-shadow: inset 0 -5px 0 rgba(0, 96, 193, 0.25);
  -webkit-transition: box-shadow 0.4s ease-in-out;
  transition: box-shadow 0.4s ease-in-out;
  &:hover {
    box-shadow: inset 0 -300px 0 rgba(0, 96, 193, 0.25);
  }
  &:focus {
    outline: 0;
  }
`;

/* eslint-disable react/prop-types */
const Link = props => (
  <GatsbyLink className={link} {...props}>
    {props.children}
  </GatsbyLink>
);

const PlainLink = props => <GatsbyLink {...props}>{props.children}</GatsbyLink>;

/* eslint-disable */
const ExtLink = props => (
  <a className={link} href={props.to}>
    {props.children}
  </a>
);

const Warning = warningtext => (
  <div><font color="red">{utf8.decode('\xE2\x9A\xA0')}
   {" "}{warningtext.children}{" "}</font></div>
);


export { Timestamp, Link,ExtLink, PlainLink,Warning };



// WEBPACK FOOTER //
// ./src/components/Misc/index.js